import { inventoryDetailsApi } from "@/services/api/inventoryDetails.api";

export const inventoryDetailsState = {
  state: {
    items: [],
    totalItem: 0,
    total: 0,
    loading: true,
    fetching: false,
    error: "",
    productItems: [],
  },
  mutations: {
    INVENTORY_ITEMS_FETCH_SUCCESS(state, payload) {
      state.items = payload.data;
      state.total = payload.data.length;
      state.totalItem = payload.totalCount;
      state.loading = false;
      state.fetching = false;
      state.productItems = [];
    },
    INVENTORY_ITEMS_FETCH_START(state) {
      state.fetching = true;
    },
    INVENTORY_ITEMS_FETCH_ERROR(state, payload) {
      state.fetching = false;
      state.error = payload;
    },

    INVENTORY_ITEMS_DETAIL_FETCH_SUCCESS(state, payload) {
      state.productItems = payload.data;
      state.loading = false;
      state.fetching = false;
    },
    INVENTORY_ITEMS_DETAIL_FETCH_START(state) {
      state.fetching = true;
    },
    INVENTORY_ITEMS_DETAIL_FETCH_ERROR(state, payload) {
      state.fetching = false;
      state.error = payload;
    },

    // update cost center
    INVENTORY_ITEM_COST_CENTER_UPDATE_SUCCESS(state, payload) {
      const index = state.items.findIndex(item => item.inventoryItemId === payload.data.inventoryItemId);
      if (index > -1) {
        // Update the item at the found index
        state.items.splice(index, 1, payload.data);
      }
    },
    INVENTORY_ITEM_COST_CENTER_UPDATE_START(state) {
      state.fetching = true;
    },
    INVENTORY_ITEM_COST_CENTER_UPDATE_ERROR(state, payload) {
      state.fetching = false;
      state.error = payload;
    },
  },
  actions: {
    getInventoryItems(context, request) {
      context.commit("INVENTORY_ITEMS_FETCH_START");

      const promise = new Promise( (resolve, reject) => {
        inventoryDetailsApi
        .getAll(request)
        .then(response => {
          context.commit("INVENTORY_ITEMS_FETCH_SUCCESS", response.data);
          resolve(response);
        })
        .catch(error => {
          context.commit("INVENTORY_ITEMS_FETCH_ERROR", error);
          reject(error);
        });
      });
      return promise;
    },
    getInventoryItemsByProduct(context, productId) {
      context.commit("INVENTORY_ITEMS_DETAIL_FETCH_START");

      const promise = new Promise( (resolve, reject) => {
        inventoryDetailsApi
        .getByProduct(productId)
        .then(response => {
          context.commit("INVENTORY_ITEMS_DETAIL_FETCH_SUCCESS", { data: response.data});
          resolve(response);
        })
        .catch(error => {
          context.commit("INVENTORY_ITEMS_DETAIL_FETCH_ERROR", error);
          reject(error);
        });
      });
      return promise;
    },
    updateCostCenter(context, payload) {
      context.commit("INVENTORY_ITEM_COST_CENTER_UPDATE_START");

      const promise = new Promise((resolve, reject) => {
        inventoryDetailsApi
          .updateCostCenter(payload.inventoryItemId, payload.costCenterId)
          .then(response => {
            context.commit("INVENTORY_ITEM_COST_CENTER_UPDATE_SUCCESS", {
              data: response.data
            });
            resolve(response);
          })
          .catch(error => {
            context.commit("INVENTORY_ITEM_COST_CENTER_UPDATE_ERROR", error);
            reject(error);
          });
      });
      return promise;
    },
  },
};
